import React, {useContext, useEffect, useState} from "react";
import "./StepFormStyles.scss";
import {Select} from "../../../components/inputs/Select";
import {MTPLTarifficationInputView} from "./Tariffication/InputView/MtplTarifficationInputView";
import {MTPLVehicleSearchView} from "./Tariffication/VehicleSearch/MtplVehicleSearchView";
import {
    findVehicleGroup,
    getConstructionYearOptions,
    mapVehicleFields,
    Vehicle,
    VehicleGroup,
    VehicleType
} from "../../../model/vehicle";
import {QuotationContext} from "../../../contexts/QuotationContext";
import {MtplQuotation} from "../../../model/quotation";
import {strings} from "../../../strings/strings";
import {MTPLVehicleTypeSelectionViewSmartDrive} from "./Tariffication/TypeSelection/MtplVehicleTypeSelectionViewSmartDrive";
import {PartyType} from "../../../model/party";
import {ErrorDialogType} from "../../../utils/hooks/useErrorDialog";
import {InfoView} from "../../../components/InfoView/infoView";
import {PhoneAndDateBirthForms} from "./PhoneAndDateBirthForms";
import {selectedViewEnam} from "../../../model/pageEnam";
import {ScenarioContext} from "../../../contexts/ScenarioContext";
import {MTPLTarifficationDescription} from "./Tariffication/MtplTarifficationDescription";
import { useHotjar } from "../../../utils/hooks/useHotjar";

interface Props {
    onFormSubmit: () => void;
    setTextErrorMessageDialog: (string) => void;
    setErrorDialogType: (errorDialogType: ErrorDialogType) => void;
    setOpenErrorMessageDialog: (bool) => void;
    setOnClose: (listener: () => void) => void;
}

export const MTPLTarrifficationFormSmartDrive = ({onFormSubmit, setOpenErrorMessageDialog, setTextErrorMessageDialog, setErrorDialogType, setOnClose}: Props) => {
    const {
        quotation,
        selectedView,
        setSelectedView,
        vehicleTypes,
        setVehicleTypes,
        vehicleGroup,
        setVehicleGroup,
        vehicleFounded,
        setVehicleFounded,
        setQuotation,
        type
    } = useContext<QuotationContext<MtplQuotation>>(QuotationContext);
    const {previousStep} = useContext(ScenarioContext);
    const [defaultVehicle, setDefaultVehicle] = useState<Vehicle>(quotation.mtplContract.vehicle);

    const {trackHotjar} = useHotjar()

    useEffect(() => {
        if (previousStep?.code !== 'mtpl_online_00005') {
            let event = 'osago_emtpl_smart_shop_buy';
            console.log('Google Analytics Event = ' + event);
            // @ts-ignore
            window.dataLayer.push({'event': event});
        }
    }, []);

    useEffect(() => {
        if( selectedView === selectedViewEnam.NEWCLIENT ){
            trackHotjar("", type )
        } else if (selectedView === selectedViewEnam.ARXCLIENT ){
            trackHotjar("login", type)
        }
    }, [selectedView])

    const resetVehicleFields = () => {
        const newQuotation = {...quotation};
        newQuotation.mtplContract.vehicle = {...defaultVehicle};
        setQuotation(newQuotation);
    };

    const emptyVehicleFields = () => {
        const newQuotation = {...quotation};
        newQuotation.mtplContract.vehicle = {
                                                id: null,
                                                vehicleType: null,
                                                brand: null,
                                                model: null,
                                                plateNumber: null,
                                                vin: null,
                                                constructionYear: null,
                                                engineType: null,
                                                batteryCapacity: null,
                                                colour: null,
                                                registerCity: null,
                                                ownerPartyType: "PERSON",
                                                ownerBirthYear: null,
                                                taxiUsage: null,
                                                requiredTO: null,
                                                nextToDate: null,
                                            } as Vehicle;
        setDefaultVehicle(newQuotation.mtplContract.vehicle);
        setQuotation(newQuotation);
    };

    let constructionYearLoadFunction = () => {
        let max = new Date().getFullYear();
        let min = 1970;
        return getConstructionYearOptions(min, max);
    };

    return (
        <div className={'step-form'}>
            {(selectedView !== selectedViewEnam.MANUAL && selectedView !== selectedViewEnam.SECONDSEARCH) &&
            <div className="step-form__toolbar">
                <div className="fast-calc">{strings.fastCalculation}</div>
                <div className="align-near">
                    <Select defaultValue={selectedView}
                            onValueSelect={setSelectedView}
                            items={[
                                {label: strings.toolbarNewClient, value: selectedViewEnam.NEWCLIENT},
                                {label: strings.toolbarARXClient, value: selectedViewEnam.ARXCLIENT}
                            ]}/>
                    <InfoView/>
                </div>
            </div>
            }
            {(selectedView === selectedViewEnam.NEWCLIENT || selectedView === selectedViewEnam.SECONDSEARCH) && !vehicleFounded && (
                <MTPLVehicleSearchView
                    onSearchListener={vehicle => {
                        if (vehicle.vehicleType == null) {
                            setErrorDialogType(ErrorDialogType.NONE);
                            setTextErrorMessageDialog(strings.smartDriveVehicleTypeMismatchError);
                            setOpenErrorMessageDialog(true);
                        }

                        if (vehicle.vehicleType !== null && !vehicle.vehicleType.includes("B")) {
                            setErrorDialogType(ErrorDialogType.NONE);
                            setTextErrorMessageDialog(strings.smartDriveVehicleTypeMismatchError);
                            setOpenErrorMessageDialog(true);
                            return;
                        }

                        if (vehicle.ownerPartyType === PartyType.ORGANIZATION) {
                            setErrorDialogType(ErrorDialogType.NONE);
                            setTextErrorMessageDialog(strings.smartDriveVehicleTypeMismatchError);
                            setOpenErrorMessageDialog(true);
                            setSelectedView(selectedViewEnam.MANUAL);
                            return;
                        }

                        resetVehicleFields();
                        const updatedVehicle = mapVehicleFields(vehicle, quotation.mtplContract.vehicle);

                        if (vehicle.vehicleType) {
                            setVehicleGroup(findVehicleGroup(vehicle.vehicleType));
                        } else {
                            setVehicleTypes([
                                VehicleType.B1, VehicleType.B2, VehicleType.B3_1, VehicleType.B3_2, VehicleType.B4, VehicleType.B5
                            ]);
                        }

                        setQuotation({
                            ...quotation, 
                            mtplContract: {
                                ...quotation.mtplContract,
                                vehicle: updatedVehicle
                            }
                        })

                        setVehicleFounded(true);
                    }} toManualInputListener={() => {
                    setSelectedView(selectedViewEnam.MANUAL);
                    const event: string = '_SD_go_manual'
                    console.log('Google Analytics Event = ' + event);
                    // @ts-ignore
                    window.dataLayer.push({'event': event});
                }}/>
            )}

            {(selectedView === selectedViewEnam.NEWCLIENT || selectedView === selectedViewEnam.SECONDSEARCH) && vehicleFounded && (
                <MTPLTarifficationInputView onSubmit={onFormSubmit}
                                            vehicleTypes={vehicleTypes}
                                            vehicleGroup={vehicleGroup}
                                            searchBy={"plateNumber"}
                                            constructionYearLoadFunction={constructionYearLoadFunction}
                                            onBackListener={() => {
                                                emptyVehicleFields();
                                                setVehicleGroup(undefined);
                                                setVehicleFounded(false);
                                            }}/>
            )}

            {selectedView === selectedViewEnam.MANUAL && !vehicleGroup && (
                <MTPLVehicleTypeSelectionViewSmartDrive onVehicleTypesSelect={(vehicleGroup: VehicleGroup) => {
                    setVehicleGroup(vehicleGroup);
                    trackHotjar(vehicleGroup, type)
                    if (vehicleGroup === VehicleGroup.B5) {
                        quotation.mtplContract.vehicle.vehicleType = VehicleType.B5;
                    }
                }}/>
            )}

            {selectedView === selectedViewEnam.MANUAL && vehicleGroup && (
                <MTPLTarifficationInputView onSubmit={onFormSubmit}
                                            vehicleGroup={vehicleGroup}
                                            constructionYearLoadFunction={constructionYearLoadFunction}
                                            onBackListener={() => {
                                                resetVehicleFields();
                                                setVehicleGroup(undefined);
                                                setVehicleFounded(false);
                                            }}/>
            )}

            {selectedView === selectedViewEnam.ARXCLIENT && (
                <PhoneAndDateBirthForms setTextErrorMessageDialog={setTextErrorMessageDialog} setOpenErrorMessageDialog={setOpenErrorMessageDialog}
                    description={MTPLTarifficationDescription}/>
            )}
        </div>
    )

};
